module.exports = __webpack_public_path__ + "static/media/2014-image.3bd2e0c1.png";